import type { Theme } from "expo-router/react-navigation";
import type { OpaqueColorValue } from "react-native";

export type FontStyle = Theme["fonts"]["regular"];

export interface CustomTheme extends Theme {
  fonts: Theme["fonts"] & {
    display: FontStyle;
    semiBold: FontStyle;
    headline: FontStyle;
  };
  colors: Theme["colors"] & {
    // base colors (expo-router types them as ColorValue; ours are always strings)
    primary: string;
    background: string;
    card: string;
    text: string;
    border: string;
    notification: string;

    // special colors
    info: string;
    success: string;
    successLight: string;
    successLighter: string;
    warning: string;
    warningLight: string;
    danger: string;
    dangerLight: string;
    semiMuted: string;
    lightMuted: string;
    muted: string;
    mutedBorder: string;
    sectionBackground: string;
    tableRowHover: string;
    modalBackground: string;
    black: string;

    // menu colors
    menuA: string;
    menuB: string;
    menuD: string;

    // from the color palette without semantic meaning. Thus no semantic name
    palette: {
      banana90: string;
      carrot100: string;
      carrot40: string;
      carrot20: string;
      lime70: string;
      lime80?: string;
      lime40: string;
      spinach30: string;
      spinach40: string;
      spinach20: string;
      spinach50: string;
      lime50: string;
      spinach90: string;
      spinach100?: string;
      gray80: string;
      gray20: string;
    };
  };
}

export type IconProps = {
  size?: number;
  color?: string | OpaqueColorValue;
};
